import { useRef, useState } from "react";
import { toast } from "sonner";
import { FileText, Upload, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fileUrl } from "@/context/SettingsContext";
import { useT } from "@/lib/i18n";
import { api, formatApiError } from "@/lib/api";

export const FileField = ({ value, onChange, testid, accept = "image/jpeg,image/png,image/webp,image/gif,application/pdf", preview = false }) => {
  const { t } = useT();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/files", fd);
      onChange(data);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const isImage = value?.content_type?.startsWith("image/");
  return (
    <div data-testid={testid} className="flex flex-wrap items-center gap-2">
      <input ref={ref} type="file" accept={accept} className="hidden" data-testid={`${testid}-input`} onChange={onFile} />
      {value ? (
        <a href={fileUrl(value.id)} target="_blank" rel="noreferrer" data-testid={`${testid}-link`}
          className="flex items-center gap-2 max-w-[260px] border border-[#282D3D] bg-[#090A0F] rounded-sm px-2 py-1.5 font-mono text-xs hover:border-[#FFB800] transition-colors duration-200">
          {preview && isImage ? <img src={fileUrl(value.id)} alt="" className="h-8 w-8 object-contain" /> : <FileText className="w-4 h-4 text-[#FFB800] shrink-0" />}
          <span className="truncate">{value.original_filename}</span>
        </a>
      ) : (
        <span className="font-mono text-xs text-slate-500">{t("file_none")}</span>
      )}
      <Button type="button" variant="outline" disabled={busy} data-testid={`${testid}-upload-btn`} onClick={() => ref.current?.click()}
        className="h-9 rounded-sm bg-transparent border-[#282D3D] hover:bg-[#181B26] hover:text-white">
        <Upload className="w-3.5 h-3.5 mr-1.5" /> {busy ? t("loading") : value ? t("replace_csv") : t("upload")}
      </Button>
      {value && (
        <button type="button" data-testid={`${testid}-remove-btn`} onClick={() => onChange(null)} title={t("remove")}
          className="h-9 w-9 flex items-center justify-center border border-[#282D3D] rounded-sm text-slate-500 hover:text-[#FF3B30] hover:border-[#FF3B30] transition-colors duration-200">
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
